/* ez-rv-capture — logs the resolved RV (year/make/model/type/slide-outs/length) from the skirting
   configurator to Supabase (ezsnap-rv-capture edge fn) on every resolved build. Fire-and-forget:
   never blocks the UI, swallows all errors, and uses keepalive so an in-flight capture survives the
   ATC navigation. The edge fn validates/clamps every field server-side (bad input is nulled, not stored).
   KEY is the public Supabase anon key (safe to embed), same project as ez-cart-share. */
(function () {
  var FN  = "https://jamovldoijekfwhmlxtm.supabase.co/functions/v1/ezsnap-rv-capture";
  var KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImphbW92bGRvaWpla2Z3aG1seHRtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEwMTE5MjAsImV4cCI6MjA4NjU4NzkyMH0.cWgAIWDfzH4_PMXdl6jAkhkPrr630urabvpOL0582no";
  window.EZSnap = window.EZSnap || {};
  window.EZSnap.rvCapture = function (payload) {
    try {
      fetch(FN, {
        method: "POST",
        headers: { Authorization: "Bearer " + KEY, apikey: KEY, "Content-Type": "application/json" },
        body: JSON.stringify(payload || {}),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  };
})();
